

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

/* form */
import FormBudgetSimpleItem from './Form/FormBudgetSimpleItem'
import RandomString from '../../../../shared/functions/RandomString'

function NewBudgetSimpleItem({ btCancelAction, handleOnSuccess, handleOnAddItem, clientId }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()




    function registerBudgetItem(budgetItem) {
        
        let data = budgetItem
        let id = RandomString(16)
        data = { ...data, id: id }

        handleOnAddItem(data)

    }

    return (
        <FormBudgetSimpleItem title="Adicionar Item" clientId={clientId} handleSubmit={registerBudgetItem} btCancelAction={btCancelAction} btnText="Concluir" btnVariant="finish" handleOnSuccess={handleOnSuccess} />
    )
}

export default NewBudgetSimpleItem